import React, { useState, useEffect } from 'react'
import './ticket-steps.less'
import { ticketlogApi } from '@/api/repair'
import { Toast } from 'antd-mobile'

function TicketSteps({ id }: any) {
  const [stepArray, setStepArray]: any = useState()
  useEffect(() => {
    const fetchData = async () => {
      Toast.loading('加载中', 0)
      const { data } = await ticketlogApi({ id })
      Toast.hide()
      if (data.code !== 'SUCCESS') {
        Toast.info(data.msg, 1.5)
        return false
      }
      setStepArray(data.data)
    }
    fetchData()
  }, [id])

  return (
    <div className="ticket-steps">
      {stepArray?.map((item: any, i: number) => (
        <div className="ticket-steps-item" key={item.id}>
          <div>
            <div
              className={
                i === 0 && stepArray?.length !== 1
                  ? 'vLine opacity-hide'
                  : 'vLine'
              }
            ></div>
            <div
              className={
                i === 0 && stepArray?.length > 1
                  ? 'ticket-circle'
                  : 'hollow-circle'
              }
            ></div>
            <div
              className={
                i === stepArray?.length - 1 ? 'vLine opacity-hide' : 'vLine'
              }
            ></div>
          </div>
          <div>
            <h3 className="font-7">{item?.text}</h3>
            <h4 className="font-8 add_time">{item?.add_time}</h4>
          </div>
        </div>
      ))}
    </div>
  )
}

export default TicketSteps
